export default __webpack_public_path__ + "static/media/ftr-logo.ac9bbc2d.png";